// extracted by mini-css-extract-plugin
export default {"renderItem":"item-text-area-styles_renderItem__cS7MM","labelTeam":"item-text-area-styles_labelTeam__sZTc6","containerScroll":"item-text-area-styles_containerScroll__2Bb2o"};